module.exports = __webpack_public_path__ + "img/2-11.8a89935e.png";